import Input from '../ui/Input';
import Icon from '../ui/Icon';

// Selector cerrado de método: solo dos opciones válidas
// (FERTIRRIEGO/COBERTERA internamente, "Fertirriego"/"Cobertera" en
// pantalla). Segmented control en vez de <select> nativo: mejor táctil en
// mobile y dos opciones no justifican un combobox.
const METODOS = [
  { value: 'FERTIRRIEGO', label: 'Fertirriego' },
  { value: 'COBERTERA', label: 'Cobertera' },
];

// Nombre comercial: texto libre digitado por el usuario. Este módulo NO
// depende de ningún catálogo (a diferencia de Aplicaciones) — se guarda
// exactamente lo escrito en aplicacion_fertilizante_detalle.nombrecomercial.
function ProductoFertilizanteForm({ index, producto, onChange, onRemove, canRemove }) {
  const handleNombre = (event) => {
    onChange({ ...producto, nombrecomercial: event.target.value });
  };

  const handleMetodo = (metodo) => {
    onChange({ ...producto, metodo });
  };

  const handleDosis = (event) => {
    onChange({ ...producto, dosis_ha: event.target.value });
  };

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-4 shadow-sm sm:p-5">
      <div className="flex items-start justify-between gap-3">
        <p className="font-medium text-gray-900">Producto {index + 1}</p>
        {canRemove && (
          <button
            type="button"
            onClick={onRemove}
            aria-label="Eliminar producto"
            title="Eliminar producto"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
          >
            <Icon name="trash" className="h-5 w-5" />
          </button>
        )}
      </div>

      <div className="mt-3 flex flex-col gap-3">
        <Input
          id={`nombrecomercial-fert-${index}`}
          label="Nombre comercial *"
          value={producto.nombrecomercial}
          onChange={handleNombre}
          placeholder="Ej: Nitrato de Calcio"
        />

        <div>
          <p className="mb-1 block text-sm font-medium text-gray-700">Método *</p>
          <div className="grid grid-cols-2 gap-2">
            {METODOS.map((metodo) => (
              <button
                key={metodo.value}
                type="button"
                onClick={() => handleMetodo(metodo.value)}
                aria-pressed={producto.metodo === metodo.value}
                className={`min-h-[48px] rounded-xl border px-4 text-base font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 ${
                  producto.metodo === metodo.value
                    ? 'border-green-600 bg-green-50 text-green-800'
                    : 'border-gray-300 text-gray-600 hover:bg-gray-50'
                }`}
              >
                {metodo.label}
              </button>
            ))}
          </div>
        </div>

        <Input
          id={`dosis-ha-${index}`}
          label="Dosis / ha *"
          value={producto.dosis_ha}
          onChange={handleDosis}
          placeholder="Ej: 25"
        />
      </div>
    </div>
  );
}

export default ProductoFertilizanteForm;
